function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import HelpIcon from 'svg/help.svg';
import App from 'modules/App';
import { getSupportUrl } from 'helpers/supportUrl';
import styles from './SupportLink.pcss';
const SupportLink = ()=>{
    const isMobileDisplayMode = useSelector(App.selectors.isMobileDisplayMode);
    const supportUrl = getSupportUrl(isMobileDisplayMode);
    if (!supportUrl) return null;
    if (isMobileDisplayMode) {
        return /*#__PURE__*/ _jsx("a", {
            href: supportUrl,
            className: styles.linkAsText,
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.linkAsText__text,
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.headers.supportHelpCenter))
            })
        });
    }
    return /*#__PURE__*/ _jsxs("a", {
        href: supportUrl,
        target: "_blank",
        className: styles.link,
        children: [
            /*#__PURE__*/ _jsx(HelpIcon, {
                className: styles.link__icon
            }),
            /*#__PURE__*/ _jsx("span", {
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.headers.help))
            })
        ]
    });
};
export default withStyles(styles)(SupportLink);
